import { api } from 'app/views/utils/api'
import settings from 'settings'

const INITIALIZE = 'INITIALIZE'
const USER_LOGGED_IN = 'USER_LOGGED_IN'
const REGISTER_ERROR = 'REGISTER_ERROR'
let token
try {
  token = localStorage.getItem('user_token')
} catch (e) {
  token = false
}

const initialState = {
  user: {
    username: null,
    email: null,
    accessToken: null,
    idToken: null,
    unauthenticatedId: null,
  },
  authenticationStatus: 'PENDING',
  token,
  plan: {
    basicPlan: 'basic-free',
    basicPrice: '0.00',
    premiumPlan: 'premium-3000-7',
    premiumPrice: '750',
  },
  registerError: null,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIALIZE:
      return {
        ...state,
        user: {
          ...state.user,
          unauthenticatedId: action.user.unauthenticatedId,
        },
        authenticationStatus: action.authenticationStatus,
      }
    case USER_LOGGED_IN:
      return {
        ...state,
        user: {
          username: action.user.username,
          email: action.user.email,
          accessToken: action.user.accessToken,
          idToken: action.user.idToken,
        },
        authenticationStatus: 'LOGGED_IN',
      }
    case REGISTER_ERROR:
      return {
        ...state,
        registerError: action.payload.error,
      }
    default:
      return state
  }
}

export function initialize(loggedIn, unauthenticatedId) {
  return {
    type: INITIALIZE,
    user: {
      unauthenticatedId,
    },
    authenticationStatus: loggedIn ? 'LOGGED_IN' : 'LOGGED_OUT',
  }
}

export function login(username, email, accessToken, idToken) {
  return dispatch => (
    dispatch({
      type: USER_LOGGED_IN,
      user: {
        username,
        email,
        accessToken,
        idToken,
      },
    })
  )
}

export function registerErrorMessage(error = '') {
  return {
    type: REGISTER_ERROR,
    payload: {
      error,
    },
  }
}
